export function extractPlanType(plan: string = "none"): string {
  const regex = /AI Studios (Starter|Pro|Creator) - \d+ minutes/;
  const match = plan?.match(regex);
  
  if (match && match[1]) {
      return match[1].toLowerCase();
  } else {
      return "free";
  }
}